import React from 'react';
import PropTypes from 'prop-types'

export default function CloseOutline({stroke})
{
	return (
		<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
			viewBox="0 0 104 99" xmlSpace="preserve" stroke={stroke} strokeWidth={5}>
			<g id="Page-1_12_">
				<g id="icons_x2F_outline_x2F_Home_x5F_32_2_">
					<g id="ic_ol_Home_2_">
						<g id="Home_1_">
							<g id="Outline-v2_21_">
								<g id="Home_4_">
									<polygon id="Page-1_13_" points="83.8,13.5 52,45.3 20.2,13.5 16,17.7 47.8,49.5 16,81.3 20.2,85.5 52,53.7 83.8,85.5 
							88,81.3 56.2,49.5 88,17.7"/>
								</g>
							</g>
						</g>
					</g>
				</g>
			</g>
		</svg>
	)
}

CloseOutline.propTypes = {
  stroke: PropTypes.string
};